import { makeStyles } from '@material-ui/core';
import { DOT, CLIPBOARD_FADE_TIME } from './constants/stylesConstants';

export default makeStyles(() => ({
  ellipsis: {
    '&::before': {
      animation: '$dots 2s linear infinite',
      content: `"${DOT}"`,
    },
  },
  '@keyframes dots': {
    '0%': {
      content: `"${DOT}"`,
    },
    '33%': {
      content: `"${DOT.repeat(2)}"`,
    },
    '66%': {
      content: `"${DOT.repeat(3)}"`,
    },
  },
  chat: {
    maxHeight: '400px',
    overflowY: 'auto', // Create scrollable area
    paddingRight: '15px',
    // '&::-webkit-scrollbar': { // Not showing scrollbar
    //   display: 'none',
    // },
    // scrollbarWidth: 'none', // Not showing scrollbar on Firefox
    '& *': {
      // Grow, then fade in
      transition: 'font-size .25s, margin .25s, padding .25s, opacity .5s .25s',
    },
  },
  hiddenChat: {
    '& *': {
      fontSize: 0,
      opacity: 0,
      padding: 0,
      margin: 0,
      // Fade out, then shrink
      transition: 'opacity .25s, font-size .5s .25s, margin .5s .25s, padding .5s .25s',
    },
  },
  message: {
    animation: '$fade-in 150ms linear',
  },
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  dataLoadingDots: {
    marginLeft: '0.4em',
    '& span': {
      display: 'inline-block',
      width: '0.6em',
      height: '0.5em',
      opacity: 0,
      animation: '$dataLoadingDots 1s infinite',
      fontSize: '1em',
    },
    '& span:nth-child(1)': {
      animationDelay: '0.2s',
    },
    '& span:nth-child(2)': {
      animationDelay: '0.4s',
    },
    '& span:nth-child(3)': {
      animationDelay: '0.6s',
    },
  },
  '@keyframes dataLoadingDots': {
    '0%, 50%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  dataLoadingText: {
    animation: '$dataLoadingText 2s ease-in-out infinite',
  },
  '@keyframes dataLoadingText': {
    '0%': {
      opacity: 0.1,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.1,
    },
  },

  dataLoadedText: {
    color: '#39ac69', // color of text when data is loaded
    display: 'flex',
    alignItems: 'center',
  },

  dataLoadingFailedText: {
    color: '#FF4646', // color of text when data loading fails
    display: 'flex',
    alignItems: 'center',
  },

  clipboardFade: {
    animation: `$clipboardFade ${CLIPBOARD_FADE_TIME}s linear`,
  },
  '@keyframes clipboardFade': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0 },
    '100%': { opacity: 1 },
  },

  // Style for creating visualization that "child" hidden unless hovered on "parent"
  parentOfHiddenUnlessHovered: {
    '&:hover $hiddenUnlessHovered': {
      opacity: 1,
      display: 'inline',
    },
  },
  hiddenUnlessHovered: {
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    display: 'none',
  },

  // Style for making clipboard button float on the top-right corner
  buttonPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '0.4rem',
    marginRight: '0.4rem',
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  parentPosition: {
    position: 'relative',
  },
}));
